import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  clearException as clearExceptionApi,
  fetchCalendar,
  replaceTemplate as replaceTemplateApi,
  setException as setExceptionApi,
} from "@/features/availability/api/availabilityApi";
import type {
  CalendarResponse,
  SetExceptionPayload,
  SetTemplatePayload,
} from "@/features/availability/types";

const CALENDAR_KEY = ["availability", "me"];

export function useCalendar() {
  return useQuery<CalendarResponse>({
    queryKey: CALENDAR_KEY,
    queryFn: fetchCalendar,
  });
}

export function useReplaceTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: SetTemplatePayload) => replaceTemplateApi(payload),
    onSuccess: (data) => {
      qc.setQueryData(CALENDAR_KEY, data);
      qc.invalidateQueries({ queryKey: ["shifts"] });
    },
  });
}

export function useSetException() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ date, payload }: { date: string; payload: SetExceptionPayload }) =>
      setExceptionApi(date, payload),
    onSuccess: (data) => {
      qc.setQueryData(CALENDAR_KEY, data);
      qc.invalidateQueries({ queryKey: ["shifts"] });
    },
  });
}

export function useClearException() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (date: string) => clearExceptionApi(date),
    onSuccess: (data) => {
      qc.setQueryData(CALENDAR_KEY, data);
      qc.invalidateQueries({ queryKey: ["shifts"] });
    },
  });
}
